export default __webpack_public_path__ + "static/media/unsupported-file.fde46995.png";